import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../Service/app-service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment'

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    NgxSpinnerModule
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  siteKey = environment.siteKey;
  captchaToken: string = '';
  loginForm!: FormGroup;
  errorMessage: string = '';
  user: any;

  constructor(private fb: FormBuilder, private authService: AuthService, private spinner: NgxSpinnerService, private router: Router, private toster: ToastrService) { }
  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: [localStorage.getItem('rememberUsername') || '', [
        Validators.required,
        Validators.pattern(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        )
      ]],
      password: [localStorage.getItem('rememberPassword') || '', Validators.required],
      rememberMe: [!!localStorage.getItem('rememberUsername')],
      recaptcha: ['', Validators.required]
    });
    this.loginForm.statusChanges.subscribe((status) => {
      console.log('Form Status:', status);
    });
  }

  onSubmit(): void {
    this.spinner.show();
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      if (this.loginForm.get('recaptcha')?.invalid) {
        this.toster.warning('Please verify the reCAPTCHA');
      }
      this.spinner.hide();
      return;
    }

    const { email, password, rememberMe } = this.loginForm.value;

    this.authService.login({ email, password }).subscribe({
      next: (response) => {
        sessionStorage.setItem('token', response.token);

        if (rememberMe) {
          localStorage.setItem('rememberUsername', email);
          localStorage.setItem('rememberPassword', password);
        } else {
          localStorage.removeItem('rememberUsername');
          localStorage.removeItem('rememberPassword');
        }

        const userId = response.user.id;
        const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        sessionStorage.setItem('userId', JSON.stringify({ userId, expirationTime }));

        this.getUserData(userId);
        this.router.navigate(['/home']).then(() => {
          this.showToast('Login successful!');
        });
        this.spinner.hide();
      },
      error: (error) => {
        this.toster.error(error.error?.message || 'Invalid email or password.')
        console.error('Login error:', error);
        this.spinner.hide();
      }
    });
  }

  showToast(message: string): void {
    const toast = document.createElement('div');
    toast.innerHTML = `
      <span style="color: white; font-weight: bold;margin-left: 100px; margin-right: 10px;">&#10004;</span>
      <span>${message}</span>
    `;
    Object.assign(toast.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      width: '400px',
      backgroundColor: '#4CAF50',
      color: 'white',
      padding: '12px 24px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      zIndex: '1000',
      opacity: '0',
      transform: 'translateX(20px)',
      transition: 'opacity 0.5s ease, transform 0.5s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    });
    document.body.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(0)';
    }, 0);
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(20px)';
      setTimeout(() => document.body.removeChild(toast), 500);
    }, 3000);
  }

  getUserData(userId: number): void {
    this.authService.getUserById(userId).subscribe({
      next: (userData) => {
        this.user = userData;
        console.log('Fetched User Data:', this.user);
      },
      error: (error) => {
        console.error('Error fetching user data:', error);
        this.errorMessage = 'Error fetching user data';
      }
    });
  }

  forgot(): void {
    this.router.navigate(['/forgot-password']);
  }
  preventSpace(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault();
    }
  }

  handleReset() {
    console.log('reCAPTCHA reset:=>', 'reCAPTCHA reset');
    this.loginForm.patchValue({ recaptcha: null });
  }

  handleExpire() {
    console.log('reCAPTCHA expired:=>', 'reCAPTCHA expired');
    this.loginForm.patchValue({ recaptcha: null });
  }


  handleLoad() {
    console.log('reCAPTCHA loaded:=>', 'reCAPTCHA loaded');
  }

  handleSuccess(captchaResponse: string) {
    console.log('CAPTCHA success token:', captchaResponse);
    this.captchaToken = captchaResponse;
    this.loginForm.patchValue({ recaptcha: captchaResponse });
  }
}
